module.exports = __webpack_public_path__ + "static/media/PDF_45.8ff3b86c.pdf";